<script setup lang="ts">
import { EDashboardType } from "@/app/data/dashboard/dashboard.types";
import { DATA_TEST_IDS } from "@/constants/data-test-ids/data-test-ids.constant";
import { useTypedIntl } from "@/locales/typed-intl";

import ContactVoltalisButton from "@/components/contact/contact-voltalis-button.vue";
import DashboardDialog from "@/components/data/dashboard/dashboard-dialog.vue";
import HospitalityButton from "@/components/ui/buttons/hospitality-button.vue";

interface IProps {
  type: EDashboardType;
}

const visible = defineModel<boolean>();
const props = defineProps<IProps>();

const { t, k } = useTypedIntl();
</script>

<template>
  <DashboardDialog
    v-model:visible="visible"
    :data-test-id="DATA_TEST_IDS.views.dashboard.missingInfos.missingDsoSubscription.dialog.component"
  >
    <template #title>
      <h4 :data-test-id="DATA_TEST_IDS.views.dashboard.missingInfos.missingDsoSubscription.dialog.title">
        {{ t(k.data.dashboard.missingDsoSubscriptionDialog.title) }}
      </h4>
    </template>

    <template #subtitle>
      <span
        class="text-text-secondary"
        :data-test-id="DATA_TEST_IDS.views.dashboard.missingInfos.missingDsoSubscription.dialog.subtitle"
      >
        {{ t(k.data.dashboard.missingDsoSubscriptionDialog.subtitle) }}
      </span>
    </template>

    <span
      class="whitespace-pre-line"
      :data-test-id="DATA_TEST_IDS.views.dashboard.missingInfos.missingDsoSubscription.dialog.content"
      >{{ t(k.data.dashboard.missingDsoSubscriptionDialog.content[props.type]) }}</span
    >

    <template #footer="{ closeCallback }">
      <div class="flex justify-end gap-2">
        <ContactVoltalisButton severity="primary" />
        <HospitalityButton
          :aria-label="t(k.global.misc.later)"
          :data-test-id="DATA_TEST_IDS.views.dashboard.missingInfos.missingDsoSubscription.dialog.laterButton"
          :label="t(k.global.misc.later)"
          severity="secondary"
          @click="closeCallback"
        />
      </div>
    </template>
  </DashboardDialog>
</template>
